import { useSnapshot } from "valtio";
import { uiState } from "./data";
import { AnimatePresence, motion } from "framer-motion";
import { googleSheet } from "./utils/getSheet";
import { useEffect } from "react";

const logoVariants = {
	right: { x: 10 },
	left: { x: -10 },
	up: { y: 10 },
	down: { y: -10 },
};

const bgVariants = {
	right: { x: -10 },
	left: { x: 10 },
	up: { y: -10 },
	down: { y: 10 },
};

export default function NewHome({ event }) {
	const { showPage1, showPage2, windowSize, direction, isInitial, prevMousePosition, btnDisable, isEnterHover } = useSnapshot(uiState[event]);
	const { isLoading } = useSnapshot(uiState);
	let data = googleSheet["homepage"] && googleSheet["homepage"][0];

	const arr = ["../index/bgTexture2.png"];

	useEffect(() => {
		const cacheImage = async (prload) => {
			const promiseLoading = arr.map((item) => {
				return new Promise((resolve, reject) => {
					const img = new Image();

					img.src = item;
					img.onload = () => resolve();
					img.onerror = () => reject();
				});
			});
			await Promise.all(promiseLoading);
			uiState.isLoading = false;
			uiState[event].showPage1 = true;
		};
		cacheImage();
		// setTimeout(() => {
		// }, 2000);
	}, []);

	// useEffect(() => {
	// 	setTimeout(() => {
	// 		uiState.isLoading = false;
	// 		uiState[event].showPage1 = true;
	// 	}, 2000);
	// }, []);

	//   const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });
	//   const [direction, setDirection] = useState("");
	//   const [prevMousePosition, setPrevMousePosition] = useState({
	//     x: null,
	//     y: null,
	//   });
	//   const [isInitial, setIsInitial] = useState(false);
	//   const [isLastAnimation, setIsLastAnimation] = useState(false);

	const handleMouseMove = (e) => {
		const { clientX, clientY } = e;
		const deltaX = clientX - prevMousePosition.x;
		const deltaY = clientY - prevMousePosition.y;

		// useState 寫法
		// if (deltaX !== 0) {
		//   if (deltaX > 0) {
		//     setDirection("right");
		//   } else {
		//     setDirection("left");
		//   }
		// }

		// if (deltaY !== 0) {
		//   if (deltaY > 0) {
		//     setDirection("down");
		//   } else {
		//     setDirection("up");
		//   }
		// }
		// setPrevMousePosition({ x: clientX, y: clientY });
		// setIsLastAnimation(!isLastAnimation);

		// uiState寫法
		if (deltaX !== 0) {
			if (deltaX > 0) {
				uiState[event].direction = "right";
			} else {
				uiState[event].direction = "left";
			}
		}

		if (deltaY !== 0) {
			if (deltaY > 0) {
				uiState[event].direction = "down";
			} else {
				uiState[event].direction = "up";
			}
		}
		uiState[event].prevMousePosition.x = clientX;
		uiState[event].prevMousePosition.y = clientY;
	};
	const goVr = () => {
		let currentUrl = window.location.href;
		var newUrl = currentUrl.replace("/start/start.html", "/vr/v0.html");
		window.location.href = newUrl;
	};
	if (isLoading) {
		return (
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				className="bg-[#cebb9f] w-screen h-screen flex justify-center items-center">
				<div className="loader"></div>
			</motion.div>
		);
	}
	return (
		<>
			<AnimatePresence>
				{showPage1 && (
					<motion.div
						className="w-screen h-dvh absolute top-0 left-0 border-[30px] border-[#2e1a0d]"
						onMouseMove={handleMouseMove}>
						<img
							src="../index/bgTexture2.png"
							loading="eager"
							className="w-full h-full object-cover"
							alt="背景"
						/>
						{/* 第一層 */}
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							transition={{ duration: 1 }}>
							<img
								src="../index/compflower01.png"
								className="scale-[.5] absolute -top-12 -left-10 z-50"
								alt="左上角花"
							/>
							<img
								src="../index/compflower02.png"
								className="scale-[.5] absolute -top-12 -right-10"
								alt="右上角花"
							/>
							<img
								src="../index/compflower03.png"
								className="scale-[.5] absolute -bottom-12 -left-10"
								alt="左下角花"
							/>
							<img
								src="../index/compflower04.png"
								className="scale-[.5] absolute -bottom-12 -right-10"
								alt="右下角花"
							/>
							<img
								src="../index/compLine05.png"
								className={`w-[50%] absolute -top-[1%]  sm:-top-[1.7%] left-[25%] ${windowSize.width > windowSize.height && "hidden"}`}
								alt="上方的中間裝飾"
							/>
							<img
								src="../index/compLine06.png"
								className={`w-[50%] absolute -bottom-[1%] sm:-bottom-[1.7%] left-[25%]
              ${windowSize.width > windowSize.height && "hidden"}`}
								alt="下方的中間裝飾"
							/>
							<img
								src="../index/compLine01.png"
								className={`h-[50%] absolute top-[20%] -left-[1%] lg:-left-[1.7%] 2xl:-left-[1%] ${windowSize.width < windowSize.height && "hidden"}`}
								alt="左邊的中間裝飾"
							/>
							<img
								src="../index/compLine02.png"
								className={`h-[50%] absolute top-[20%] -right-[1%] lg:-right-[1.7%] 2xl:-right-[1%]
              ${windowSize.width < windowSize.height && "hidden"}`}
								alt="右邊的中間裝飾"
							/>

							<img
								src="../index/compDec01.png"
								className={` absolute ${
									windowSize.width > windowSize.height ? "w-[30%] sm:w-[28%] 2xl:w-[20%] top-[1%] left-[4%]" : "w-[40%] top-[5%] left-[4%]"
								}`}
								alt="左上角樹枝"
							/>
							<img
								src="../index/line01.png"
								className={`absolute ${windowSize.width > windowSize.height ? "h-[60%] top-[15%] left-[4%]" : "h-[70%] top-[15%] left-[4%]"}`}
								alt="左邊中間的線"
							/>
							<img
								src="../index/dot01.png"
								className={` absolute ${
									windowSize.width > windowSize.height
										? "w-[2%] sm:w-[1.5%] 2xl:w-[1%] lg:w-[2%] 2xl:w-[1.5%] top-[45%] sm:top-[43%] left-[6%]"
										: "w-[4%] top-[45%] left-[6%]"
								}`}
								alt="左邊中間的圓點"
							/>
							<img
								src="../index/compDec03.png"
								className={`absolute ${
									windowSize.width > windowSize.height ? "w-[30%] sm:w-[28%] 2xl:w-[20%] bottom-[1%] left-[4%]" : "w-[40%] bottom-[5%] left-[4%]"
								}`}
								alt="左下角樹枝"
							/>

							<img
								src="../index/compDec02.png"
								className={` absolute ${
									windowSize.width > windowSize.height ? "w-[30%] sm:w-[28%] 2xl:w-[20%] top-[1%] right-[4%]" : "w-[40%] top-[5%] right-[4%]"
								}`}
								alt="右上角樹枝"
							/>
							<img
								src="../index/line01.png"
								className={`absolute  ${windowSize.width > windowSize.height ? "h-[60%] top-[15%] right-[4%]" : "h-[70%] top-[15%] right-[4%]"}`}
								alt="右邊中間的線"
							/>
							<img
								src="../index/dot01.png"
								className={` absolute rotate-[180deg] ${
									windowSize.width > windowSize.height
										? "w-[2%] sm:w-[1.5%] 2xl:w-[1%] lg:w-[2%] 2xl:w-[1.5%] top-[45%] sm:top-[43%] right-[6%]"
										: "w-[4%] top-[45%] right-[6%]"
								}`}
								alt="右邊中間的圓點"
							/>
							<img
								src="../index/compDec04.png"
								className={`absolute ${
									windowSize.width > windowSize.height ? "w-[30%] sm:w-[28%] 2xl:w-[20%] bottom-[1%] right-[4%]" : "w-[40%] bottom-[5%] right-[4%]"
								}`}
								alt="右下角樹枝"
							/>

							<img
								src="../index/logoNation.png"
								className={`absolute ${
									windowSize.width > windowSize.height ? "w-[23%] 2xl:w-[20%] left-[40%] top-[10%]" : "w-[50%] left-[22%] smart:left-[24%] top-[14%]"
								}`}
								alt="國立國父紀念館"
							/>
						</motion.div>
						<motion.div
							initial={{ opacity: 0, x: 0, y: 0 }}
							animate={{ opacity: 1 }}
							transition={{ duration: 1, delay: 1 }}
							className={`z-10 absolute ${
								windowSize.width > windowSize.height
									? "w-[34%] md:w-[30%] lg:w-[40%] xl:w-[42%] 2xl:w-[32%] top-[40%] sm:top-[35%] md:top-[38%] lg:top-[32%] 2xl:top-[35%] left-[34%] smart1:left-[36%] lg:left-[33%] 2xl:left-[35%]"
									: "w-[30%] sm:w-[30%] top-[35%] smart:top-[37%] sm:top-[33%] lg:left-[36%] sm:left-[36%] left-[36%]"
							}`}>
							<motion.div
								animate={isInitial && direction !== "" && direction}
								variants={logoVariants}
								transition={{ duration: 1 }}>
								<img
									src={`${windowSize.width > windowSize.height ? "../index/logoTitle.png" : "../index/ph_logoTitle.png"}`}
									className="object-contain"
									alt="島嶼+記憶 logo"
								/>
							</motion.div>
						</motion.div>
						<motion.div
							initial={{ opacity: 0, x: 0, y: 0 }}
							animate={{ opacity: 1 }}
							transition={{ duration: 1, delay: 2 }}
							onAnimationComplete={() => {
								uiState["homepage"].isInitial = true;
								uiState["homepage"].btnDisable = false;
							}}
							className={`absolute ${
								windowSize.width > windowSize.height
									? "w-[80%] sm:w-[65%] md:w-[70%] lg:w-[75%] xl:w-[75%] 2xl:w-[63%] top-[28%] sm:top-[28%] left-[10%] sm:left-[18%] md:left-[18%] lg:left-[15%] xl:left-[13%] 2xl:left-[19%]"
									: "w-[60%] sm:w-[50%] lg:w-[80%] top-[32%] smart:top-[34%] sm:top-[30%] lg:top-[28%] left-[18%] sm:left-[25%] lg:left-[25%]"
							}`}>
							<motion.div
								animate={isInitial && direction !== "" && direction}
								variants={bgVariants}
								transition={{ duration: 1 }}>
								<img
									src={`${windowSize.width > windowSize.height ? "../index/bgImg.png" : "../index/ph_bgImg.png"}`}
									className="object-contain"
									alt="島嶼+記憶 背景"
								/>
							</motion.div>

							<button
								disabled={btnDisable}
								className={`z-50 fixed  left-1/2 -translate-x-1/2 hover:scale-[1.1] hover:cursor-pointer ${
									windowSize.width > windowSize.height ? "sm:w-[30px] md:w-[50px] lg:w-[50px] bottom-[10%] " : "w-[30px] sm:w-[50px] bottom-[15%]"
								} `}
								// className={`z-[100] absolute hover:scale-[1.1] hover:cursor-pointer ${
								// 	windowSize.width > windowSize.height
								// 		? "w-[30px] lg:w-[50px] xl:w-[60px] -bottom-[10%] lg:-bottom-[30%] smart1:-bottom-[7%] 2xl:-bottom-[0%] left-[45%] smart1:left-[47%] lg:left-[45%] xl:left-[48%] 2xl:left-[48%]"
								// 		: "w-[40px] lg:w-[60px] -bottom-[30%] smart:-bottom-[45%] sm:-bottom-[10%] lg:-bottom-[15%] left-[40%] smart:left-[43%] lg:left-[28%]"
								// }`}
								onClick={() => {
									uiState[event].showPage1 = false;
									uiState[event].showPage2 = true;
									uiState[event].isInitial = false;
									uiState["homepage"].btnDisable = true;
								}}>
								<img
									src="../index/btn_GoIntro.png"
									className="object-contain"
									alt="進入按鈕"
								/>
							</button>
						</motion.div>
					</motion.div>
				)}
				{/* </AnimatePresence>
      <AnimatePresence> */}
				{showPage2 && (
					<motion.div
						className="w-screen h-dvh absolute top-0 left-0 overflow-hidden"
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}>
						<img
							src="../index/bgTexture2.png"
							className="w-full h-full object-cover"
							alt="背景"
						/>
						<motion.div
							key={`second_${showPage2}`}
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							transition={{ duration: 1, delay: 0 }}
							onAnimationComplete={() => {
								uiState["homepage"].btnDisable = false;
							}}>
							<button
								disabled={btnDisable}
								// className={`z-50 absolute hover:scale-[1.1] hover:cursor-pointer ${
								// 	windowSize.width > windowSize.height
								// 		? "sm:w-[30px] lg:w-[50px] xl:w-[60px] sm:top-[5%] sm:left-[48%] lg:left-[48%] 2xl:left-[45%]"
								// 		: "w-[30px] sm:w-[50px] top-[5%] left-[46%]"
								// }`}
								className={`z-50 fixed top-[5%] sm:top-[35px] left-1/2 -translate-x-1/2 hover:scale-[1.1] hover:cursor-pointer ${
									windowSize.width > windowSize.height ? "sm:w-[30px] md:w-[50px] lg:w-[50px]" : "w-[30px] sm:w-[50px]"
								}`}
								onClick={() => {
									uiState[event].showPage2 = false;
									uiState[event].showPage1 = true;
									uiState["homepage"].btnDisable = true;
								}}>
								<img
									src="../index/btn_back.png"
									className="object-contain"
									alt="返回按鈕"
								/>
							</button>
							<motion.div
								initial={{ x: -20 }}
								animate={{ x: 5 }}
								transition={{ duration: 1, delay: 0 }}
								className={`absolute ${
									windowSize.width > windowSize.height
										? "sm:w-[40%] 2xl:w-[35%] sm:-top-[35%] lg:-top-[30%] xl:-top-[34%] sm:-left-[20%] lg:-left-[17%]"
										: "w-[60%] sm:w-[55%] top-[3%] sm:top-[5%] -left-[45%] sm:-left-[40%]"
								}`}>
								<img
									src="../index/comp_PicFrame.png"
									className={`object-contain ${windowSize.width > windowSize.height ? "rotate-[30deg]" : "rotate-[110deg]"}`}
									alt="左上角邊框"
								/>
							</motion.div>

							<motion.div
								initial={{ x: -40 }}
								animate={{ x: 5 }}
								transition={{ duration: 1 }}
								className={`absolute ${
									windowSize.width > windowSize.height
										? "sm:w-[40%] 2xl:w-[35%] sm:-bottom-[35%] md:-bottom-[35%] lg:-bottom-[30%] xl:-bottom-[32%] sm:-left-[20%] lg:-left-[20%]"
										: "w-[60%] sm:w-[55%] bottom-[3%] sm:bottom-[5%] -left-[50%] sm:-left-[45%]"
								}`}>
								<img
									src="../index/comp_PicFrame.png"
									className={`object-contain ${windowSize.width > windowSize.height ? "rotate-[75deg]" : "rotate-[120deg]"}`}
									alt="左下角邊框"
								/>
							</motion.div>

							<motion.div
								initial={{ x: 100 }}
								animate={{ x: 5 }}
								transition={{ duration: 1 }}
								className={`absolute ${
									windowSize.width > windowSize.height
										? "sm:w-[40%] 2xl:w-[35%] sm:-top-[15%] md:-top-[25%] lg:top-[0%] 2xl:-top-[10%] sm:-right-[25%] lg:-right-[27%]"
										: "w-[60%] sm:w-[55%] -top-[10%] sm:-top-[20%] -right-[50%] sm:-right-[30%]"
								}`}>
								<img
									src="../index/comp_PicFrame.png"
									className={`object-contain ${windowSize.width > windowSize.height ? "rotate-[160deg]" : "rotate-[165deg]"}`}
									alt="右上角邊框"
								/>
							</motion.div>

							<motion.div
								initial={{ x: 100 }}
								animate={{ x: 5 }}
								transition={{ duration: 1 }}
								className={`absolute ${
									windowSize.width > windowSize.height
										? "sm:w-[40%] 2xl:w-[35%] sm:-bottom-[25%] md:-bottom-[25%] lg:-bottom-[30%] xl:-bottom-[32%] 2xl:-bottom-[38%] sm:-right-[22%] lg:-right-[22%]"
										: "w-[60%] sm:w-[55%] -bottom-[4%] sm:-bottom-[7%] -right-[50%] sm:-right-[45%]"
								}`}>
								<img
									src="../index/comp_PicFrame.png"
									className={`object-contain ${windowSize.width > windowSize.height ? "rotate-[100deg]" : "rotate-[55deg]"}`}
									alt="右下角邊框"
								/>
							</motion.div>

							<motion.div
								className=" z-50 absolute top-[15%] left-[20%]"
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								transition={{ duration: 1, delay: 0.5 }}>
								<h2
									className={`text-base sm:text-2xl GenYoMin-SB font-semibold ${windowSize.width > windowSize.height ? "sm:pt-4" : ""} GenYoMin-SB`}>
									{data.zh_title}
								</h2>
								<article
									className={`w-3/4 text-sm sm:text-base mt-4 h-[45dvh] overflow-y-auto whitespace-pre-wrap ${
										windowSize.width > windowSize.height ? "sm:h-[25dvh] md:h-[35dvh] lg:w-3/4 2xl:w-3/4 lg:h-[45dvh] lg:text-xl" : ""
									} GenYoMin-SB font-semibold`}>
									<p className="GenYoMin-SB font-semibold">{data.zh_content.replace("策展人：莊慈", "")}</p>
									<p className="eb-garamond">{data.en_content}</p>
								</article>
								<p
									className={`text-right text-xs sm:text-base mt-4 sm:mt-8 pr-[20%]  ${
										windowSize.width > windowSize.height
											? "sm:text-base md:text-xl sm:pr-32 md:pr-44 lg:pr-56 xl:pr-72 2xl:pr-96"
											: "sm:pr-36 md:pr-[30%] lg:pr-52"
									} GenYoMin-SB font-semibold`}>
									策展人：莊慈
								</p>
							</motion.div>
							<button
								className={`fixed ${
									windowSize.width > windowSize.height ? "sm:w-[100px] lg:w-[180px]" : "w-[75px] smart:w-[100px] sm:w-[125px] md:w-[150px]"
								} left-1/2 -translate-x-1/2 bottom-[15%]`}
								// className={`absolute ${
								// 	windowSize.width > windowSize.height
								// 		? "sm:w-[100px] lg:w-[180px] sm:left-[43%] md:left-[44%] lg:left-[41%] xl:left-[43%] sm:bottom-[16%]"
								// 		: "w-[75px] smart:w-[100px] sm:w-[125px] md:w-[150px] lg:w-[170px] bottom-[14%] md:bottom-[16%]  left-[37%] smart:left-[35%] sm:left-[40%]"
								// }`}
								onMouseEnter={() => {
									uiState[event].isEnterHover = true;
								}}
								onMouseLeave={() => {
									uiState[event].isEnterHover = false;
								}}
								onClick={goVr}>
								<img
									src={`${isEnterHover ? "../index/btn_enter_hover.png" : "../index/btn_enter.png"}`}
									className="object-contain"
									alt="進入參觀按鈕"
								/>
							</button>
							<div
								className={`absolute ${
									windowSize.width > windowSize.height ? "sm:w-[65%] bottom-[5%] sm:left-[17%]" : "w-[65%] bottom-[5%] left-[17%]"
								}`}>
								<img
									src={`${windowSize.width > windowSize.height ? "../index/logoAll.png" : "../index/logoAll_phone.png"}`}
									className="object-contain"
									alt="指導單位:文化部 主辦單位:國立國父紀念館 統籌指導:王蘭生 展覽執行:昀禾創藝有限公司"
								/>
							</div>
						</motion.div>
					</motion.div>
				)}
			</AnimatePresence>
		</>
	);
}
